import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col import-tab" }
const _hoisted_4 = /*#__PURE__*/_createVNode("button", { class: "import-tab__button-change" }, "ИМПОРТ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("button", { class: "import-tab__button-change" }, " ИМПОРТ ОТ STATGOV ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("button", { class: "import-tab__button-change" }, "редактировать", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/admin/import",
          exact: ""
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/admin/import-statgov",
          exact: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          "active-class": "active",
          to: "/admin/bulletin-change",
          exact: ""
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}